<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
    <div class="form-horizontal">
      <div class="row">
        <div class="col-md-12">          
            <div class="form-group row">
            <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                [Label]="'VOZILO.NAZIV.SINGULAR'"
                name="txtNaziv"                                    
                #autofocus
                autocomplete="off"
                formControlName = "Naziv"
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                  <span *ngFor="let validation of errorMessages.Naziv">
                    <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
           
          </div>

          <div class="form-group row">
            <div class="col-md-6">
              <yt-fw-date-picker-popup
              formControlName="DatumReg"
              name="txtDatumReg"
              [Label]="'VOZILO.DATUMREG.SINGULAR'"
              [ngClass]="{ 'is-invalid': submitted && fc.DatumReg.invalid }"
              >
            </yt-fw-date-picker-popup>
            <div class="form-error" *ngIf="submitted && fc.DatumReg.invalid">
              <span *ngFor="let validation of errorMessages.DatumReg">
                <span class="error-message" *ngIf="fc.DatumReg.hasError(validation.type)"><span
                    translate="{{ validation.message }}"></span></span>
              </span>
            </div>
          </div>
            <div class="col-md-6">
                <yt-dropdown-picklist
                [ModelName]="'vrstavozila'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                formControlName="VrstaVozilaId"
                 [Label]="'VOZILO.VRSTAVOZILA.SINGULAR'"
                 [ngClass]="{
                   'is-invalid':
                     submitted && fc.VrstaVozilaId.invalid
                 }" 
                 [AllowAddNew]="true"
               >
               </yt-dropdown-picklist>
              <div class="form-error" *ngIf="submitted && fc.VrstaVozilaId.invalid">
                <span *ngFor="let validation of errorMessages.VrstaVozilaId">
                  <span class="error-message" *ngIf="fc.VrstaVozilaId.hasError(validation.type)"><span
                      translate="{{ validation.message }}"></span></span>
                </span>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-6">
              <yt-input
                [Type]="'text'"
                [Label]="'VOZILO.RGBR.SINGULAR'"
                name="txtRgBr"                                    
                autocomplete="off"
                formControlName = "RgBr"
                [ngClass]="{'is-invalid': submitted && fc.RgBr.invalid}"
                #autofocus
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.RgBr.invalid">
                  <span *ngFor="let validation of errorMessages.RgBr">
                    <span class="error-message" *ngIf="fc.RgBr.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
            <div class="col-md-6">
              <yt-input
                [Type]="'text'"
                [Label]="'VOZILO.BRSBDOZV.SINGULAR'"
                name="txtBrSbDozv"                                    
                autocomplete="off"
                formControlName = "BrSbDozv"
                [ngClass]="{'is-invalid': submitted && fc.BrSbDozv.invalid}"
                #autofocus
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.BrSbDozv.invalid">
                  <span *ngFor="let validation of errorMessages.BrSbDozv">
                    <span class="error-message" *ngIf="fc.BrSbDozv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
          </div>
         
          <div class="form-group row">
            <div class="col-md-6">
              <yt-input
                [Type]="'text'"
                [Label]="'VOZILO.MARKA.SINGULAR'"
                name="txtMarka"                                    
                autocomplete="off"
                formControlName = "Marka"
                [ngClass]="{'is-invalid': submitted && fc.Marka.invalid}"
                #autofocus
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Marka.invalid">
                  <span *ngFor="let validation of errorMessages.Marka">
                    <span class="error-message" *ngIf="fc.Marka.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
            <div class="col-md-6">
              <yt-input
                [Type]="'text'"
                [Label]="'VOZILO.MODEL.SINGULAR'"
                name="txtModel"                                    
                autocomplete="off"
                formControlName = "Model"
                [ngClass]="{'is-invalid': submitted && fc.Model.invalid}"
                #autofocus
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Model.invalid">
                  <span *ngFor="let validation of errorMessages.Model">
                    <span class="error-message" *ngIf="fc.Model.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-6">
              <yt-number-input-v3
                  name="txtMasa" 
                  [Label]="'VOZILO.MASA.SINGULAR'" 
                  formControlName="Masa"
                  >
              </yt-number-input-v3>
                <div class="form-error" *ngIf="submitted && fc.Masa.invalid">
                  <span *ngFor="let validation of errorMessages.Masa">
                    <span class="error-message" *ngIf="fc.Masa.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
            <div class="col-md-6">
              <yt-number-input-v3
                  name="txtNosivost" 
                  [Label]="'VOZILO.NOSIVOST.SINGULAR'" 
                  formControlName="Nosivost"
                  >
              </yt-number-input-v3>
                <div class="form-error" *ngIf="submitted && fc.Nosivost.invalid">
                  <span *ngFor="let validation of errorMessages.Nosivost">
                    <span class="error-message" *ngIf="fc.Nosivost.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-6">
              <yt-number-input-v3
                  name="txtBrojOsovina" 
                  [Label]="'VOZILO.BROJOSOVINA.SINGULAR'" 
                  formControlName="BrojOsovina"
                  [FormatString]="'1.0-0'">
              </yt-number-input-v3>
                <div class="form-error" *ngIf="submitted && fc.BrojOsovina.invalid">
                  <span *ngFor="let validation of errorMessages.BrojOsovina">
                    <span class="error-message" *ngIf="fc.BrojOsovina.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
            <div class="col-md-6">
              <yt-input
                  name="txtGodinaProizvodnje" 
                  [Label]="'VOZILO.GODINAPROIZVODNJE.SINGULAR'" 
                  formControlName="GodinaProizvodnje"
                  [MaxLength]="4">
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.GodinaProizvodnje.invalid">
                  <span *ngFor="let validation of errorMessages.GodinaProizvodnje">
                    <span class="error-message" *ngIf="fc.GodinaProizvodnje.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-6">
              <yt-input
                [Type]="'text'"
                [Label]="'VOZILO.BOJA.SINGULAR'"
                name="txtBoja"                                    
                autocomplete="off"
                formControlName = "Boja"
                [ngClass]="{'is-invalid': submitted && fc.Boja.invalid}"
                #autofocus
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.Boja.invalid">
                  <span *ngFor="let validation of errorMessages.Boja">
                    <span class="error-message" *ngIf="fc.Boja.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
            <div class="col-md-6">
              <yt-input
                [Type]="'text'"
                [Label]="'VOZILO.BROJSASIJE.SINGULAR'"
                name="txtBrojSasije"                                    
                autocomplete="off"
                formControlName = "BrojSasije"
                [ngClass]="{'is-invalid': submitted && fc.BrojSasije.invalid}"
                #autofocus
                >
              </yt-input>
                <div class="form-error" *ngIf="submitted && fc.BrojSasije.invalid">
                  <span *ngFor="let validation of errorMessages.BrojSasije">
                    <span class="error-message" *ngIf="fc.BrojSasije.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                  </span>
                </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>